import React from "react";
import { useTranslation } from "utilities/i18n";
import { useRouteMatch } from "react-router";
import { NavLink, Redirect, Route, Switch } from "polyrouter";
import { Layout } from "views/Main/Layouts";
import { ProtectedNavLink, ProtectedRoute } from "TsRoleGuards";
import { TrialRouter } from "./Trial/TrialRouter";
import { TrialReportRouter } from "./TrialReport/TrialReportRouter";
import { usePermissions } from "rbac";

const AdminRouter: React.FC = () => {
  const { t } = useTranslation();
  const detailsMatchView = useRouteMatch<{ view: string }>([
    "/clariti/:view/details"
  ]);
  const detailsView = detailsMatchView?.params?.view;
  const isDetailsView = !!detailsView;

  let back;
  if (detailsMatchView) {
    let backButtonMessage;
    let persist;

    switch (detailsView) {
      case "trial-report":
        backButtonMessage = t("CLARITI");
        break;
      default:
        backButtonMessage = t("UNKNOWN");
        break;
    }

    const backTo = detailsMatchView?.url?.split("/details")[0] ?? "/clariti";

    back = {
      to: backTo,
      title: backButtonMessage,
      iconDesc: backButtonMessage,
      persist: persist
    };
  }

  const { Sidebar } = Layout;
  return (
    <Layout back={back}>
      {!isDetailsView && (
        <Sidebar>
          <span className="title-capitalized">{t("CLARITI")}</span>
          <ul className="menu router">
            <li>
              <NavLink nest to="/trial">
                {t("TRIAL")}
              </NavLink>
            </li>
            <li>
              <ProtectedNavLink
                nest
                to="/trial-report"
                requirement="clariti-trial:ReadSubscriptions"
              >
                {t("TRIAL_USER_REPORT")}
              </ProtectedNavLink>
            </li>
          </ul>
        </Sidebar>
      )}
      <Switch nest>
        <Route nest path="/trial">
          <TrialRouter />
        </Route>
        <ProtectedRoute
          nest
          path="/trial-report"
          requirement="clariti-trial:ReadSubscriptions"
        >
          <TrialReportRouter />
        </ProtectedRoute>
        <Redirect nest to="/trial" />
      </Switch>
    </Layout>
  );
};

const UserRouter: React.FC = () => {
  return (
    <Layout>
      <Switch nest>
        <Route nest path="/trial">
          <TrialRouter />
        </Route>
        <Redirect nest to="/trial" />
      </Switch>
    </Layout>
  );
};

export const ClaritiRouter: React.FC = () => {
  const hasPermission = usePermissions();
  const hasClaritiTrialAdminPermission = hasPermission(
    "clariti-trial:ReadSubscriptions"
  );
  return hasClaritiTrialAdminPermission ? <AdminRouter /> : <UserRouter />;
};
